import React from 'react'
import FormTile from 'src/components/common/containers/FormTile'
import CustomerDataDownload from 'src/components/rewards/setup/customer-details/CustomerDataDownload'
import RewardsBulkUpload from 'src/components/rewards/setup/customer-details/RewardsBulkUpload'
import CustomerSpecificDetails from 'src/components/rewards/setup/customer-details/CustomerSpecificDetails'
import CustomerRewardsExpiryDownload from 'src/components/rewards/setup/customer-details/CustomerRewardsExpiryDowload'

const CustomerDetails: React.FC<{}> = ({}) => {
  return (
    <>
      <FormTile title={'Customers'}>
        <>
          <CustomerSpecificDetails />
          <ul className='flex flex-col border divide-y rounded-lg border-gray-light divide divide-gray-light'>
            <li className='p-3 cursor-pointer'>
              <RewardsBulkUpload />
            </li>
            <li className='p-3 cursor-pointer'>
              <CustomerDataDownload />
            </li>
            <li className='p-3 cursor-pointer'>
              <CustomerRewardsExpiryDownload />
            </li>
          </ul>
        </>
      </FormTile>
    </>
  )
}

export default CustomerDetails
